export const pinFormat = {
    Output: {
        5: "1",
        6: "2",
        13: "3",
        19: "4",
        25: "5",
        26: "6",
        27: "7",
        28: "8"
    },
    Input: {
        21: "1",
        20: "2",
        16: "3",
        12: "4",
        4: "5",
        3: "6",
        2: "7",
        1: "8"
    }
};